// import { del, post, put } from '@/utils/request'
import { executeApp } from '@/utils/request'
import {
  CLASSROOM, CLASSROOM_AGENT, CLASSROOM_EXAM,
  CLASSROOM_EXAM_TEMPLATE,
  CLASSROOM_EXERCISE, CLASSROOM_FILE_HISTORY,
  CLASSROOM_LEARNING_SPACE,
  CLASSROOM_LEARNING_SPACE_AGENT, CLASSROOM_LESSON, CLASSROOM_LESSON_DOCUMENT,
  CLASSROOM_LESSON_PLAN, CLASSROOM_QUESTION,
  CLASSROOM_QUESTION_BANK,
  CLASSROOM_STUDENT,
  CLASSROOM_TEACHING_PLAN,
  EXERCISE,
  KNOWLEDGE_DOCUMENT,
  WORKSPACE,
} from '@/api/defineRouting'

/**
 * Classroom
 */

export function createClassroom<T = any>(data: any) {
  return executeApp<T>(CLASSROOM.CREATE, data, 'post',
  )
}
export function getListClassroom<T = any>(data: any) {
  return executeApp<T>(CLASSROOM.LIST, data, 'post',
  )
}

export function detailClassroom<T = any>(data: any) {
  return executeApp<T>(CLASSROOM.DETAIL, data, 'get',
  )
}

export function updateClassroom<T = any>(data: any) {
  return executeApp<T>(CLASSROOM.UPDATE, data, 'put',
  )
}

export function deleteClassroom<T = any>(data: any) {
  return executeApp<T>(CLASSROOM.DELETE, data, 'delete',
  )
}

/**
 * Learning Space
 */
export function createClassroomLearningSpace<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LEARNING_SPACE.CREATE, data, 'post',
  )
}

export function getListClassroomLearningSpace<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LEARNING_SPACE.LIST, data, 'post',
  )
}

export function detailClassroomLearningSpace<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LEARNING_SPACE.DETAIL, data, 'get',
  )
}

export function updateClassroomLearningSpace<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LEARNING_SPACE.UPDATE, data, 'put',
  )
}

export function deleteClassroomLearningSpace<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LEARNING_SPACE.DELETE, data, 'delete',
  )
}

export function createAutoClassroomLearningSpace<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LEARNING_SPACE.CREATE_AUTO, data, 'post',
  )
}

/**
 * Classroom Student
 */
export function addStudentsToClassroom<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_STUDENT.CREATE, data, 'post',
  )
}

export function deleteStudentsFromClassroom<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_STUDENT.DELETE, data, 'delete',
  )
}

export function getListStudentInClassroom<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_STUDENT.LIST, data, 'post',
  )
}

export function shareClassroom<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_STUDENT.CREATE_LINK, data, 'post',
  )
}

export function joinClassroom<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_STUDENT.TOKEN, data, 'post',
  )
}

export function getListStudentJoinClassroom<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_STUDENT.LIST_STUDENT, data, 'post',
  )
}

export function addStudentJoinClassroom<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_STUDENT.ADD_STUDENT, data, 'post',
  )
}

export function getListClassroomForStudent<T = any>() {
  return executeApp<T>(CLASSROOM_STUDENT.LIST_CLASSROOM, {}, 'post',
  )
}

export function getStudentJoinClassroom<T = any>() {
  return executeApp<T>(CLASSROOM_STUDENT.GET_STUDENT, {}, 'post',
  )
}

export function cancelRequestJoinClassroom<T = any>() {
  return executeApp<T>(CLASSROOM_STUDENT.CANCEL_REQUEST, {}, 'delete',
  )
}

/**
 * Learning Space Agent
 */

export function createClassroomLearningSpaceAgent<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LEARNING_SPACE_AGENT.CREATE, data, 'post',
  )
}

export function getAllAgentClassroomLearningSpaceAgent<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LEARNING_SPACE_AGENT.LIST_ALL_AGENT, data, 'get',
  )
}

export function getAgentClassroomLearningSpaceAgent<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LEARNING_SPACE_AGENT.LIST_AGENT, data, 'post',
  )
}

export function deleteClassroomLearningSpaceAgent<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LEARNING_SPACE_AGENT.DELETE, data, 'delete',
  )
}

/**
 * Lesson
 */

export function createLesson<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LESSON.CREATE, data, 'post',
  )
}
export function getListLesson<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LESSON.LIST, data, 'post',
  )
}

export function detailLesson<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LESSON.DETAIL, data, 'get',
  )
}

export function updateLesson<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LESSON.UPDATE, data, 'put',
  )
}

export function deleteLesson<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LESSON.DELETE, data, 'delete',
  )
}

/**
 * Exercise
 */
export function getListExerciseInClassroom<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_EXERCISE.LIST, data, 'post',
  )
}
export function detailExerciseInClassroom<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_EXERCISE.DETAIL, data, 'get',
  )
}
export function getListAnswerInClassroom<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_EXERCISE.ANSWER, data, 'post',
  )
}
export function updateExerciseInClassroom<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_EXERCISE.UPDATE, data, 'put',
  )
}
export function deleteExerciseInClassroom<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_EXERCISE.DELETE, data, 'delete',
  )
}
export function createExerciseInClassroom<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_EXERCISE.CREATE, data, 'post',
  )
}
export function updateStatusExerciseInClassroom<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_EXERCISE.UPDATE_STATUS, data, 'post',
  )
}
export function exportExerciseInClassroom<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_EXERCISE.EXPORT, data, 'get',
  )
}

export function getListEmailWorkspace<T = any>(data: any) {
  return executeApp<T>(WORKSPACE.LIST_EMAIL, data, 'post',
  )
}

/**
 * Question
 */
export function createQuestion<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_QUESTION.CREATE, data, 'post',
  )
}
export function getListQuestion<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_QUESTION.LIST, data, 'post',
  )
}
export function detailQuestion<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_QUESTION.DETAIL, data, 'get',
  )
}
export function updateQuestion<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_QUESTION.UPDATE, data, 'put',
  )
}
export function deleteQuestion<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_QUESTION.DELETE, data, 'delete',
  )
}
export function generateQuestion<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_QUESTION.GENERATE, data, 'post',
  )
}
export function generateExamQuestion<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_QUESTION.GENERATE_EXAM, data, 'post',
  )
}

/**
 * Lesson Document
 */
export function createLessonDocument<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LESSON_DOCUMENT.CREATE, data, 'post',
  )
}
export function createByFileLessonDocument<T = any>(params: any) {
  const formData = new FormData()
  params.file
	&& formData.append('file', params.file)
  params.data && formData.append('data', JSON.stringify(params.data))
  return executeApp<T>(CLASSROOM_LESSON_DOCUMENT.CREATE_BY_FILE, formData, 'post',
  )
}
export function getLessonDocument<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LESSON_DOCUMENT.LIST, data, 'post',
  )
}
export function detailLessonDocument<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LESSON_DOCUMENT.DETAIL, data, 'get',
  )
}
export function updateLessonDocument<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LESSON_DOCUMENT.UPDATE, data, 'put',
  )
}
export function deleteLessonDocument<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LESSON_DOCUMENT.DELETE, data, 'delete',
  )
}
export function updateStatusLessonDocument<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LESSON_DOCUMENT.UPDATE_STATUS, data, 'post',
  )
}

/**
 * Lesson Plan
 */
export function createLessonPlan<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LESSON_PLAN.CREATE, data, 'post',
  )
}

export function createByFileLessonPlan<T = any>(params: any) {
  const formData = new FormData()
  Object.keys(params).forEach((key) => {
    formData.append(key, params[key])
  })
  return executeApp<T>(CLASSROOM_LESSON_PLAN.CREATE_BY_FILE, formData, 'post',
  )
}

export function getListLessonPlan<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LESSON_PLAN.LIST, data, 'post',
  )
}

export function detailLessonPlan<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LESSON_PLAN.DETAIL, data, 'get',
  )
}

export function updateLessonPlan<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LESSON_PLAN.UPDATE, data, 'put',
  )
}

export function deleteLessonPlan<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_LESSON_PLAN.DELETE, data, 'delete',
  )
}

export function getExerciseDetailInfoList<T = any>(data: any) {
  return executeApp<T>(EXERCISE.DETAIL_INFO_LIST, data, 'post',
  )
}

export function getExerciseListOfStudent<T = any>(data: any) {
  return executeApp<T>(EXERCISE.LIST_OF_STUDENT, data, 'post',
  )
}

export function submitExercise<T = any>(data: any) {
  return executeApp<T>(EXERCISE.SUBMIT, data, 'post',
  )
}

export function getStudentExerciseSubmitDetail<T = any>(data: any) {
  return executeApp<T>(EXERCISE.SUBMIT_DETAIL, data, 'post',
  )
}

export function gradeExercise<T = any>(data: any) {
  return executeApp<T>(EXERCISE.GRADE_EXERCISE, data, 'post',
  )
}

export function gradeExerciseManually<T = any>(data: any) {
  return executeApp<T>(EXERCISE.GRADE_EXERCISE_MANUALLY, data, 'post',
  )
}

export function getListStudentExerciseSubmitProgress<T = any>(data: { classroom_id: number; source_id: number; source_type: string }) {
  return executeApp<T>(EXERCISE.GET_LIST_STUDENT_EXERCISE_SUBMIT_PROGRESS, data, 'post',
  )
}
export function summariseClassroomResult<T = any>(data: any) {
  return executeApp<T>(EXERCISE.SUMMARISE_CLASSROOM_RESULT, data, 'post',
  )
}
export function getListExResultForStudent<T = any>(data: any) {
  return executeApp<T>(EXERCISE.GET_LIST_EX_RESULT_FOR_STUDENT, data, 'post',
  )
}

/**
 * Exercise Rankings
 */
export function rankStudentsByExerciseResults<T = any>(data: any) {
  return executeApp<T>('/classroom-service/exercise/rank-students-by-exercise-results', data, 'post')
}

/**
 * Teaching Plan
 */
export function createTeachingPlan<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_TEACHING_PLAN.CREATE, data, 'post',
  )
}

export function getListTeachingPlan<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_TEACHING_PLAN.LIST, data, 'post',
  )
}

export function getDetailTeachingPlan<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_TEACHING_PLAN.DETAIL, data, 'get',
  )
}

export function deleteTeachingPlan<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_TEACHING_PLAN.DELETE, data, 'delete',
  )
}

export function getListTeachingPlanGroupByClassroom<T = any>(data: { workspace_id: number; subject: string }) {
  return executeApp<T>(`${CLASSROOM_TEACHING_PLAN.GET_LIST_GROUP_BY_CLASSROOM}`, data, 'post')
}

export function getListLessonPlanGroupByClassroom<T = any>(data: { workspace_id: number; subject: string }) {
  return executeApp<T>(`${CLASSROOM_LESSON_PLAN.GET_LIST_GROUP_BY_CLASSROOM}`, data, 'post')
}

export function getListKnowledgeBase<T = any>() {
  return executeApp<T>(KNOWLEDGE_DOCUMENT.GET_LIST_OF_KNOWLEDGE_DOCUMENT_BY_KNOWLEDGE_BASE, {}, 'post')
}

export function getListExerciseGroupByLesson<T = any>(data: { learning_space_id: number; workspace_id: number; source_type: string }) {
  return executeApp<T>(CLASSROOM_EXERCISE.GET_LIST_GROUP_BY_LESSON, data, 'post')
}

export function getDocumentList<T = any>(data: { workspace_id: number }) {
  return executeApp<T>(CLASSROOM_TEACHING_PLAN.GET_LIST_DOCUMENT, { workspace_id: data.workspace_id }, 'post')
}

/**
 * Question Bank
 */
export function getListQuestionBank<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_QUESTION_BANK.LIST, data, 'post',
  )
}

export function detailQuestionBank<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_QUESTION_BANK.DETAIL, data, 'post',
  )
}

export function deleteQuestionBank<T = any>(data: any) {
  return executeApp<T>(`${CLASSROOM_QUESTION_BANK.DELETE}/${data.id}`, {}, 'delete',
  )
}

/**
 * Exam Template
 */

export function createExamTemplate<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_EXAM_TEMPLATE.CREATE, data, 'post',
  )
}
export function getListExamTemplate<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_EXAM_TEMPLATE.LIST, data, 'post',
  )
}

export function detailExamTemplate<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_EXAM_TEMPLATE.DETAIL, data, 'get',
  )
}

export function updateExamTemplate<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_EXAM_TEMPLATE.UPDATE, data, 'put',
  )
}

export function deleteExamTemplate<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_EXAM_TEMPLATE.DELETE, data, 'delete',
  )
}

export function cloneExamTemplate<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_EXAM_TEMPLATE.CLONE, data, 'post',
  )
}

/**
 * Exam
 */

export function createExam<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_EXAM.CREATE, data, 'post',
  )
}
export function getListExam<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_EXAM.LIST, data, 'post',
  )
}

export function getListExamForStudent<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_EXAM.LIST_FOR_STUDENT, data, 'post',
  )
}

export function detailExam<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_EXAM.DETAIL, data, 'get',
  )
}

export function detailExamForStudent<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_EXAM.DETAIL_FOR_STUDENT, data, 'get',
  )
}

export function updateExam<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_EXAM.UPDATE, data, 'put',
  )
}

export function deleteExam<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_EXAM.DELETE, data, 'delete',
  )
}

export function getExamSubmitSummaryInfo<T = any>(data: { workspace_id: number; classroom_id: number; subject_id: number; subject: string; exam_type: string; keyword: string; page: number; page_size: number; sort: boolean; sort_by: string }) {
  return executeApp<T>(CLASSROOM_EXAM.GET_EXAM_SUBMIT_SUMMARY_INFO, data, 'post')
}

/**
 * Classroom Agent
 */

export function createClassroomAgent<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_AGENT.CREATE, data, 'post',
  )
}

export function getAllAgentClassroomAgent<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_AGENT.LIST_ALL_AGENT, data, 'get',
  )
}

export function getAgentClassroomAgent<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_AGENT.LIST_AGENT, data, 'post',
  )
}

export function deleteClassroomAgent<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_AGENT.DELETE, data, 'delete',
  )
}

/**
 * Classroom File History
 */

export function listFileHistoryClassroom<T = any>(data: any) {
  return executeApp<T>(CLASSROOM_FILE_HISTORY.LIST, data, 'post',
  )
}

export function deleteFileHistoryClassroom<T = any>(data: { source_id: number | string; source_type: string }) {
  return executeApp<T>(CLASSROOM_FILE_HISTORY.DELETE_HISTORY, data, 'delete',
  )
}

/**
 * Save content to lesson document
 */
export function saveContentToLessonDocument<T = any>(data: {
  lesson_id: number
  source_id: string
  source_type: string
  content: string
  name: string
}) {
  return executeApp<T>(CLASSROOM_LESSON_DOCUMENT.CREATE, data, 'post')
}
